
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class WIPTransactionDialog extends Serenity.EntityDialog<WIPTransactionRow, any> {
        protected getFormKey() { return WIPTransactionForm.formKey; }
        protected getIdProperty() { return WIPTransactionRow.idProperty; }
        protected getLocalTextPrefix() { return WIPTransactionRow.localTextPrefix; }
        protected getNameProperty() { return WIPTransactionRow.nameProperty; }
        protected getService() { return WIPTransactionService.baseUrl; }
        protected getDeletePermission() { return WIPTransactionRow.deletePermission; }
        protected getInsertPermission() { return WIPTransactionRow.insertPermission; }
        protected getUpdatePermission() { return WIPTransactionRow.updatePermission; }

        protected form = new WIPTransactionForm(this.idPrefix);

    }
}